import React, { useEffect, useState } from "react";
import { fetchPieces, fetchCountPublishedReviewsForPrompt } from "../services/api";
import Spinner from "./Spinner";

const SubmittedPiecesTotal = ({ startDate, promptId }) => {
  const [metrics, setMetrics] = useState({
    submittedCount: null,
    submittedUsers: null,
    publishedUsers: null,
    startedUsers: null,
    publishedReviews: null,
  });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchAndCompute = async () => {
      setIsLoading(true);
      try {
        const [data, reviewsCountResp] = await Promise.all([
          fetchPieces(startDate, promptId),
          fetchCountPublishedReviewsForPrompt(promptId),
        ]);

        const submitted = data.filter(
          entry => entry.raw_submitted_at && entry.raw_submitted_at !== "NaT"
        );

        const submittedUsersCount = new Set(
          data
            .filter(entry => entry.submitted !== false)
            .map(entry => entry.user_id)
        ).size;

        const published = data.filter(
          entry => entry.raw_published_at && entry.raw_published_at !== "NaT"
        );
        const publishedUserCount = new Set(published.map(entry => entry.user_id)).size;

        const startedUserCount = new Set(data.map(entry => entry.user_id)).size;

        setMetrics({
          submittedCount: submitted.length,
          submittedUsers: submittedUsersCount,
          publishedUsers: publishedUserCount,
          startedUsers: startedUserCount,
          publishedReviews: reviewsCountResp?.count ?? null,
        });
      } catch (err) {
        console.error("Failed to load metrics", err);
      } finally {
        setIsLoading(false);
      }
    };

    setMetrics({ submittedCount: null, submittedUsers: null, publishedUsers: null, startedUsers: null, publishedReviews: null });
    fetchAndCompute();
  }, [startDate, promptId]);

  return (
    <>
      {isLoading ? (
        <Spinner label="Loading metrics…" />
      ) : (
        <>
          <MetricCard label="# of Users who Submitted" value={metrics.submittedUsers} />
          <MetricCard label="# of Users who Started Pieces" value={metrics.startedUsers} />
          <MetricCard label="# of Published Reviews" value={metrics.publishedReviews} />
        </>
      )}
    </>
  );
};

const MetricCard = ({ label, value }) => (
  <div style={{ textAlign: "center" }}>
    <p style={{ fontSize: "16px", color: "#555", marginBottom: 4 }}>{label}</p>
    <h1 style={{ fontSize: "36px", margin: 0 }}>{value !== null ? value : "..."}</h1>
  </div>
);

export default SubmittedPiecesTotal;
